document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-compose-remove-box]');

  if (!button) return;

  const boxId = button.dataset.composeRemoveBox;

  if (!boxId || button.disabled) return;

  try {
    button.disabled = true;

    const cartResponse = await fetch(
      `${window.Shopify.routes.root}cart.js`
    );

    if (!cartResponse.ok) {
      throw new Error('Unable to load cart.');
    }

    const cart = await cartResponse.json();
    const updates = {};

    cart.items.forEach((item) => {
      if (
        item.properties &&
        item.properties._compose_box_id === boxId
      ) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      return;
    }

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates })
      }
    );

    if (!response.ok) {
      const error = await response.json();

      throw new Error(
        error.description ||
        error.message ||
        'Unable to remove box.'
      );
    }

    window.location.reload();
  } catch (error) {
    console.error('Compose box removal error:', error);
    button.disabled = false;
    alert(error.message);
  }
});